import React, { useContext, useEffect, useState } from "react";
import Footer from "../components/Footer";
import { AuthContext } from "../context/auth";
import { useNavigate, useParams } from "react-router-dom";
import SuccessAlert from "../admin/components/SuccessAlert";

export default function SubmitReviewOrQuestion() {

  const { authorizeUserData } = useContext(AuthContext);
  const { query } = useParams();
  const navigate = useNavigate();

  const [heading, setHeading] = useState("Submit Your Feedback or Question");
  const [formReason, setFormReason] = useState();
  const [success, setSuccess] = useState("");

  const [formData, setFormData] = useState({
    user_img: "",
    user_name: "",
    user_email: "",
    user_query_type: "",
    user_message: "",
    user_booking_id: "",
  });

  const [loading, setLoading] = useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);

  if (loading && authorizeUserData) {
    setFormData({
      user_img: authorizeUserData.user_img,
      user_name: `${authorizeUserData.user_first_name} ${authorizeUserData.user_last_name}`,
      user_email: authorizeUserData.user_email,
      user_query_type: "",
      user_message: "",
      user_booking_id: "",
    });
    setLoading(false);
  }

  const queryTypeHeading = (query) => {
    if (query == "feedback") {
      setHeading("Submit Your Feedback");
    } else if (query == "askQuestion") {
      setHeading("Ask Your Question");
    } else if (query == "cancelBooking") {
      setHeading("Request Booking Cancellation");
    }
  };

  const queryFormReason = (query) => {
    if (query == "feedback") {
      setFormReason("Feedback");
    } else if (query == "askQuestion") {
      setFormReason("Question");
    } else if (query == "cancelBooking") {
      setFormReason("Booking Cancellation");
    }
  };
  
  const submitFormHandler = async (e) => {
    e.preventDefault();
    window.scrollTo(0,0);
    setSubmitLoading(true);
    
    try{
    const response = await fetch("https://hotelbnb-backend.onrender.com/add-contacts-toDb", {
      method : "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body:JSON.stringify(formData),
    });

    if(response.ok){
      window.scrollTo(0,0);
      setSuccess("Success! Thanks For Your Submission");
      setTimeout(() => {
        navigate("/");
      }, 3000);
    } 
    }catch (error) {
      console.log(error);
    } finally {
      setSubmitLoading(false);
    }
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    queryTypeHeading(query);
  }, []);

  useEffect(() => {
    queryFormReason(query);
    setFormData({
      ...formData,
      user_query_type : formReason,
    })
  }, [formReason]);


  if (submitLoading)
    return (
      <div className="d-flex flex-column gap-2 justify-content-center align-items-center loading-state">
        <div className="spinner-grow" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p>Submitting...</p>
      </div>
    );

  if (!submitLoading)
  return (
    <>
      {/* Heading Start */}
      <div className="container-fluid p-0 hero-section-spacing">
        <div className="row app-container">
          <h3 className="search-for-room-heading search-hotel-bookNow-heading mt-3">
            {heading}
          </h3>
        </div>
      </div>
      {/* Heading End */}

      {/* Showing Alert based on http request response Start */}
      <div className="container-fluid p-0">
        <div className="row app-container mt-3">
          {success && <SuccessAlert successMsg={success} />}
        </div>
      </div>
      {/* Showing Alert based on http request response End */}

      {/* Review Or Question Form */}
      <div className="container-fluid p-0">
        <div
          className="row app-container signup-form-cover reviewQuestion-form"
          id="reviewQuestion-form"
        >
          <form method="post" className="p-0" onSubmit={submitFormHandler}>
            <div className="d-flex gap-3 signup-form-row">
              <div className="col p-0 signup-col">
                <label className="form-label">Name</label>
                <input
                  type="text"
                  name="user_name"
                  placeholder="Enter Your Name"
                  className="form-control text-capitalize"
                  required
                  value={formData.user_name}
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      user_name: e.target.value,
                    });
                  }}
                />
              </div>
              <div className="col p-0 signup-col">
                <label className="form-label">Email</label>
                <input
                  type="text"
                  name="user_email"
                  placeholder="Enter Your Email"
                  className="form-control"
                  required
                  value={formData.user_email}
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      user_email: e.target.value,
                    });
                  }}
                />
              </div>
            </div>

            <div className="d-flex gap-3 signup-form-row">
              <div className="col p-0 signup-col">
                <label className="form-label">Reason</label>
                <input
                  type="text"
                  name="user_query_type"
                  className="form-control"
                  required
                  value={formData.user_query_type}
                  readOnly
                />
              </div>
              {query == "cancelBooking" ? (
                <div className="col p-0 signup-col">
                  <label className="form-label">Booking Id</label>
                  <input
                    type="text"
                    name="user_booking_id"
                    placeholder="Enter Your Booking Id"
                    className="form-control"
                    required
                    value={formData.user_booking_id}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        user_booking_id: e.target.value,
                      });
                    }}
                  />
                </div>
              ) : (
                ""
              )}
            </div>

            <div className="d-flex gap-3 signup-form-row">
              <div className="col p-0 signup-col">
                <textarea
                  name="user_message"
                  placeholder={
                    query == "feedback" || query == "askQuestion"
                      ? "Type Here"
                      : "Type Your Reason Of Cancellation"
                  }
                  className="form-control"
                  required
                  value={formData.user_message}
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      user_message: e.target.value,
                    });
                  }}
                ></textarea>
              </div>
            </div>
            <button
              type="submit"
              className="btn custom-btn signup-btn rounded-pill d-block mx-auto"
            >
              Submit
            </button>
          </form>
        </div>
      </div>
      {/* Review Or Question Form End */}

      {/* Footer Start */}
      <Footer />
      {/* Footer End */}
    </>
  );
}
